export const NAME = 'appointmentFee';